import { SVGProps } from 'react'

export const EventOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" fill="none" viewBox="0 0 25 24" {...props}>
    <path
      fill="currentColor"
      d="M19.25 5h-2V3h-10v2h-2c-1.1 0-2 .9-2 2v1c0 2.55 1.92 4.63 4.39 4.94a5.01 5.01 0 003.61 2.96V19h-4v2h10v-2h-4v-3.1a5.01 5.01 0 003.61-2.96c2.47-.31 4.39-2.39 4.39-4.94V7c0-1.1-.9-2-2-2zm-14 3V7h2v3.82c-1.16-.42-2-1.52-2-2.82zm7 6c-1.65 0-3-1.35-3-3V5h6v6c0 1.65-1.35 3-3 3zm7-6c0 1.3-.84 2.4-2 2.82V7h2v1z"
    ></path>
  </svg>
)
